
const actions = {
  view: {
    register: 'view/register',
    remove: 'view/remove',
    registerTarget: 'view/registerTarget',
    registerSource: 'view/registerSource',
    deleteTarget: 'view/deleteTarget',
    deleteSource: 'view/deleteSource',
    setExitView: 'view/setExitView',
    updateSourceRect: 'view/updateSourceRect',
    setScreen: 'view/setScreen',
    updateViewScreen: 'view/updateViewScreen',
    setExitScroll: 'view/setExitScroll',
    clearScenes: 'view/clearScenes',
  },
};

export default actions;
